import { useMemo } from 'react';
import {
  RecreationalG,
  RecreationalPath,
  RecreationalPolyline,
  MedicalG,
  MedicalPath,
  MedicalPolyline,
  LimitedPath,
  LimitedPolyline,
  NotLegalPath,
} from '../styles';
import { buildMap } from '../utility';
import { states } from './states';
import dispensaries from '../../../helper/constants/dispensaries-data';
import { dispensaryHashNormalize } from '../../../helper/utility';

const States = () => {
  const dispensariesHashMap = useMemo(()=>dispensaryHashNormalize(dispensaries),[]);
  const stateMap = useMemo(
    () =>
      states.map((state) => {
        const isDispensary = !!dispensariesHashMap[state.name];
        switch (state.type) {
          case 'RecreationalG':
            return buildMap({ state, Element: RecreationalG, isDispensary });
          case 'RecreationalPath':
            return buildMap({ state, Element: RecreationalPath, isDispensary });
          case 'RecreationalPolyline':
            return buildMap({ state, Element: RecreationalPolyline, isPoints: true, isDispensary });
          case 'MedicalPath':
            return buildMap({ state, Element: MedicalPath, isDispensary });
          case 'MedicalG':
            return buildMap({ state, Element: MedicalG, isDispensary });
          case 'MedicalPolyline':
            return buildMap({ state, Element: MedicalPolyline, isPoints: true, isDispensary });
          case 'LimitedPath':
            return buildMap({ state, Element: LimitedPath, isDispensary });
          case 'LimitedPolyline':
            return buildMap({ state, Element: LimitedPolyline, isPoints: true, isDispensary });
          case 'NotLegalPath':
            return buildMap({ state, Element: NotLegalPath, isDispensary });
          default:
            return null;
        }
      }),
    [],
  );

  return <>{stateMap}</>;
};

export default States;
